import React from 'react';
import { useTheme } from './ThemeContext';

const SettingsView = ({ onBack, t }) => {
  const { currentTheme, themes, changeTheme } = useTheme();

  const handleThemeChange = (themeName) => {
    changeTheme(themeName);
  };

  return (
    <div className="settings-view">
      {/* Enhanced Header */}
      <div className="enhanced-settings-header">
        <div className="settings-header-content">
          <div className="enhanced-back-button" onClick={onBack}>
            ← {t.back || 'Back'}
          </div>
          <div className="settings-info-enhanced">
            <h1>{t.settings || 'Settings'}</h1>
            <p>{t.customizeYourExperience || 'Customize your experience'}</p>
          </div>
          <div className="settings-icon">⚙️</div>
        </div>
      </div>

      {/* Settings Content */}
      <div className="enhanced-settings-content">
        {/* Theme Selection Section */}
        <div className="settings-section">
          <div className="section-header-settings">
            <h2 className="section-title-settings">🎨 {t.themeSelection || 'Theme Selection'}</h2>
            <p className="section-description">{t.chooseYourStyle || 'Choose your preferred style'}</p>
          </div>
          
          <div className="theme-grid">
            {Object.entries(themes).map(([themeKey, theme]) => (
              <div
                key={themeKey}
                className={`theme-card ${currentTheme === themeKey ? 'active' : ''}`}
                onClick={() => handleThemeChange(themeKey)}
              >
                <div className="theme-preview" style={{
                  background: theme.colors.background,
                  borderColor: theme.colors.border
                }}>
                  <div className="theme-preview-header" style={{
                    background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.secondary})`,
                    fontFamily: theme.fonts.primary
                  }}>
                    <span className="theme-emoji">{theme.emoji}</span>
                  </div>
                  <div className="theme-preview-content" style={{
                    backgroundColor: theme.colors.cardBackground,
                    color: theme.colors.textPrimary,
                    fontFamily: theme.fonts.secondary
                  }}>
                    <div className="preview-text" style={{ color: theme.colors.textPrimary }}>
                      Sample Text
                    </div>
                    <div className="preview-button" style={{
                      background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.secondary})`,
                      borderRadius: theme.borderRadius.medium
                    }}>
                      Button
                    </div>
                  </div>
                </div>
                
                <div className="theme-info">
                  <h3 className="theme-name">{theme.name}</h3>
                  <div className="theme-description">
                    {themeKey === 'kid-friendly' && (t.kidFriendlyDesc || 'Playful and colorful design')}
                    {themeKey === 'professional' && (t.professionalDesc || 'Clean and modern business style')}
                    {themeKey === 'rock-roll' && (t.rockRollDesc || 'Bold and edgy rock style')}
                    {themeKey === 'blue' && (t.blueDesc || 'Calm and peaceful blue tones')}
                    {themeKey === 'romance' && (t.romanceDesc || 'Elegant and romantic design')}
                  </div>
                  
                  {currentTheme === themeKey && (
                    <div className="current-theme-badge">
                      ✓ {t.currentTheme || 'Current Theme'}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Other Settings Sections */}
        <div className="settings-section">
          <div className="section-header-settings">
            <h2 className="section-title-settings">🌐 {t.language || 'Language'}</h2>
            <p className="section-description">{t.selectLanguage || 'Select your preferred language'}</p>
          </div>
          
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">{t.currentLanguage || 'Current Language'}</span>
              <span className="setting-value">{t.language || 'English'}</span>
            </div>
            <div className="setting-control">
              <span className="setting-note">{t.languageNote || 'Language settings available in header'}</span>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-settings">
            <h2 className="section-title-settings">📱 {t.preferences || 'Preferences'}</h2>
            <p className="section-description">{t.appPreferences || 'Application preferences'}</p>
          </div>
          
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">{t.notifications || 'Notifications'}</span>
              <span className="setting-description">{t.notificationDesc || 'Receive order updates'}</span>
            </div>
            <div className="setting-control">
              <label className="toggle-switch">
                <input type="checkbox" defaultChecked />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">{t.soundEffects || 'Sound Effects'}</span>
              <span className="setting-description">{t.soundDesc || 'Play sounds for interactions'}</span>
            </div>
            <div className="setting-control">
              <label className="toggle-switch">
                <input type="checkbox" defaultChecked />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
        </div>

        {/* Theme Preview Info */}
        <div className="settings-section">
          <div className="theme-info-card">
            <div className="theme-info-header">
              <span className="current-theme-emoji">{themes[currentTheme].emoji}</span>
              <h3>{t.currentlyUsing || 'Currently Using'}: {themes[currentTheme].name}</h3>
            </div>
            <p className="theme-info-text">
              {t.themeApplied || 'This theme is applied across all pages and components in the app.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsView; 